module.exports = __webpack_public_path__ + "static/media/aeronave.3ad602a8.png";